module.exports = __webpack_public_path__ + "img/people.32939e05.svg";